import z from "zod";

const relationshipSchema = z.object({
  blocked_by: z.boolean().catch(false),
  blocking: z.boolean().catch(false),
  followed_by: z.boolean().catch(false),
  following: z.boolean().catch(false),
  id: z.string(),
  muting: z.boolean().catch(false),
  note: z.string().catch(""),
  notifying: z.boolean().catch(false),
});

type Relationship = z.infer<typeof relationshipSchema>;

export { relationshipSchema, type Relationship };
